export const pageTitleCapitalization = {
  textTransform: 'capitalize',
}

export const sectionTitleCapitalization = {
  textTransform: 'none',
}
